import React, { useState, useRef } from "react";
import { StyleSheet, View, Animated, Dimensions } from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../../../Utils/responsive";
import "../../../../App.scss";
import Intro from "./intro";
import Page1 from "./page1";
import Page2 from "./page2";
import Page3 from "./page3";
import Page4 from "./page4";
import Page5 from "./page5";
import Header from "../../../../Components/MandG/Header/index";
import { custom4 } from "../../../../Utils/static-strings";

export default function Index(props) {
  const [display, setDisplay] = useState(true);
  const [pageSecond, setPageSecond] = useState(true);
  const [pageThird, setPageThird] = useState(true);
  const [pageFourth, setPageFourth] = useState(true);
  const [pageFifth, setPageFifth] = useState(true);
  const [skippedQuestion, setSkippedQuestion] = useState(false);
  const isMandGSA =
    sessionStorage.getItem("skinName")?.toLowerCase() ===
    custom4?.toLowerCase();

  const safeModuleObject =
    props.moduleObject && props.moduleObject.questions
      ? props.moduleObject
      : { ...props.moduleObject, questions: [] };

  const Refresh = () => {
    setPageSecond(false);
  };
  const pageThree = () => {
    setPageThird(false);
  };
  const pageFour = () => {
    setPageFourth(false);
  };
  const pageFive = () => {
    setPageFifth(false);
  };
  return (
    <div
      className="exp-mandg-scroll"
      style={{
        width: "100%",
        height: "100%",
        minHeight: "100%",
        position: "absolute",
        backgroundColor: "var(--game-background-color-exp)",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Header currentRoute={"Understanding"} />

      {display ? (
        <Intro setDisplay={setDisplay} />
      ) : pageSecond ? (
        <Page1 Refresh={Refresh} {...props} moduleObject={safeModuleObject} />
      ) : pageThird ? (
        <Page2
          Refresh={pageThree}
          setSkippedQuestion={setSkippedQuestion}
          skippedQuestion={skippedQuestion}
          {...props}
          moduleObject={safeModuleObject}
        />
      ) : pageFourth ? (
        <Page3
          Refresh={pageFour}
          {...props}
          moduleObject={safeModuleObject}
          setSkippedQuestion={setSkippedQuestion}
          skippedQuestion={skippedQuestion}
        />
      ) : pageFifth ? (
        <Page4
          Refresh={pageFive}
          {...props}
          moduleObject={safeModuleObject}
          setSkippedQuestion={setSkippedQuestion}
          skippedQuestion={skippedQuestion}
        />
      ) : (
        <Page5
          {...props}
          moduleObject={safeModuleObject}
          setSkippedQuestion={setSkippedQuestion}
          skippedQuestion={skippedQuestion}
        />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100vw",
    flex: 1,
    backgroundColor: "#ff0000",
    overflow: "hidden",
  },
  topborder: {
    position: "relative",
    alignSelf: "center",
    borderTopColor: "var(--module-color-pb)",
    borderTopWidth: 3,
    marginBottom: hp("1.2%"),
  },
  Image: {
    position: "relative",
    alignSelf: "flex-end",
    marginLeft: "90vw",
    width: 48,
    resizeMode: "contain",
    marginRight: 8,
    height: 12,
  },
});
